import {
  ColumnLayout,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import PLCFields from './plcFields';

export default function HeatZoneConfig({ fieldsBySide }) {
  return (
    <ColumnLayout columns={3}>
      <PLCFields
        title="Hold Mode Config"
        description="Normal heating mode. PID controls temperature to setpoint with no active cooling. Switches to Pull-Down Mode when overshoot exceeds the Pull-Down Entry Delta."
        fields={fieldsBySide.hold}
      />
      <PLCFields
        title="Pull-Down Mode Config"
        description="Overshoot recovery mode. Keeps cooling active above setpoint and heater is fully off. Returns to Hold Mode early when temperature drops the Hold Entry Delta below setpoint, or once stable."
        fields={fieldsBySide.pullDown}
      />
      <PLCFields
        title="Safety Limits"
        description="Critical and warning limits enforced by the PLC safety checks."
        fields={fieldsBySide.safety}
      />
    </ColumnLayout>
  );
}
HeatZoneConfig.propTypes = {
  fieldsBySide: PropTypes.shape({
    hold: PLCFields.propTypes.fields,
    pullDown: PLCFields.propTypes.fields,
    safety: PLCFields.propTypes.fields,
  }).isRequired,
};
